import React, { useEffect } from "react";
import { Snackbar, Alert } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import "./styles.css";

const SuccessAlert = ({ open, message, onClose, duration = 10000 }) => {
  useEffect(() => {
    if (open && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [open, duration, onClose]);

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      className="success-alert-snackbar"
      onClose={onClose}
      sx={{
        bottom: "6% !important",
        left: "3% !important"
      }}
    >
      <Alert
        icon={<CheckCircleOutlineIcon className="success-alert-icon" />}
        severity="success"
        className="success-alert"
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SuccessAlert;
